import { createSlice } from '@reduxjs/toolkit';
import { ViewerWrapper } from '../../../../Viewer/ViewerWrapper';
import { isClientSide } from '../../../utils';
import { com } from '../../../../generated/proto-generated';

export interface SiteConfigState {
  data: {
    viewer: ViewerWrapper | undefined;
    activeLayoutType: com.wixpress.wixdocs.ViewerConfig.LayoutType;
    scrollDirection: string;
  };
  status: 'idle' | 'loading' | 'failed';
}

const siteConfigInitialState: SiteConfigState = {
  data: { viewer: undefined, activeLayoutType: undefined, scrollDirection: '' },
  status: 'idle',
};

const loadSiteConfigInitialState = (initialState = siteConfigInitialState) => {
  if (isClientSide()) {
    const viewer = new ViewerWrapper(window?.__VIEWER__);
    initialState.data.viewer = viewer.toObject();
    initialState.data.activeLayoutType = viewer.viewerConfig.layoutType;
  }
  return initialState;
};

export const siteConfigSlice = createSlice({
  name: 'siteConfig',
  initialState: loadSiteConfigInitialState(),
  reducers: {
    setSiteConfig: (state, action) => {
      state.data.viewer = action.payload.viewer;
      if (!state.data.activeLayoutType) {
        state.data.activeLayoutType = state.data.viewer.viewerConfig.layoutType;
      }
    },
    setSiteActiveLayoutType: (state, action) => {
      state.data.activeLayoutType = action.payload.layoutType;
    },
    setScrollDirection: (state, action) => {
      state.data.scrollDirection = action.payload.scrollDirection;
    },
  },
});

export default siteConfigSlice.reducer;
